import { ComponentChildren, FunctionalComponent, h } from 'preact'
import { Chip } from '../chip'
import Icon from '../../assets'
import ListGroup from '../list-group'

interface Props {
  pills: string[]
  dropdown: ComponentChildren
  isControl?: boolean
  onPillClick: (pill: string) => void
  id: string
  label?: string
  subtext?: string
}

const MultiSelectionTagField: FunctionalComponent<Props> = ({
  pills = [],
  isControl = false,
  onPillClick,
  dropdown,
  label,
  subtext,
  id
}: Props) => (
  <div
    className={`o-multi-selection-tag-field o-multi-selection-tag-field--app-${
      isControl ? 'control' : 'destination'
    }`}
  >
    {label && (
      <label className='a-multi-selection-tag-field--label' for={id}>
        {label}
      </label>
    )}
    {subtext && (
      <p className='a-multi-selection-tag-field--subtext'>{subtext}</p>
    )}
    <div className='o-multi-selection-tag-field_configuration-section'>
      {pills.length > 0 && (
        <ListGroup spacing={DesignTokens.SpacingEnum.S4}>
          {pills.map((pillLabel, index) => (
            <Chip
              key={index}
              variant='squared'
              size='small'
              endIcon={<Icon icon='close' width={14} height={14} />}
              onClick={() => onPillClick(pillLabel)}
            >
              {pillLabel}
            </Chip>
          ))}
        </ListGroup>
      )}
      {dropdown}
    </div>
  </div>
)

export default MultiSelectionTagField
